import { ChangeEvent, FC, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'

import './style.scss'
import { Layout } from '../../../containers'
import { Title, Text, Select, Button } from '../../../components/UI'
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs'
import { MedicalAppointments, MedicalAppointmentsUpcomings, MedicalAppointmentsDocuments } from '../../../components'
import { useAppointments, useFamilyGroup } from '../../../hooks'
import config from '../../../../config'

const tabClass = 'react-tabs__tab react-tabs_col-4'

const MedicalAppointmentPage:FC = () => {
  const [tabIndex, setTabIndex] = useState<number>(0)
  const appointmentUpcomingsData = useAppointments('UPCOMINGS')
  const appointmentData = useAppointments('ALL')
  const [appointmentFilterSelected, setAppointmentFilterSelected] = useState<string>('')
  const appointmentDocumentsData = useAppointments('DOCUMENTS')
  const familyFilter = useFamilyGroup('FILTER')
  const params: any = useParams()

  useEffect(() => {
    if(params.id === 'horas-pasadas') setTabIndex(1)
    else if(params.id === 'solicitar-documento') setTabIndex(2)
    else if(params.id > 0) onAppointmentDataReload(params.id)
    else setTabIndex(0)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params])

  const onTabSelectChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const { target: { value } } = event
    setTabIndex(Number(value))
  }

  const onAppointmentDataReload = (patientId: string) => {
    setAppointmentFilterSelected(patientId)
    appointmentUpcomingsData.get('UPCOMINGS', patientId)
    appointmentData.get('ALL', patientId)
  }

  // get url query parameters, get from_family_group
  const urlParams = new URLSearchParams(window.location.search);
  const fromFamilyGroup = urlParams.get('from_family_group');
  const patientId = urlParams.get('patient_id');

  return (
    <Layout menu titleMain={2}>
      <Title size="14" border className="lg:d-none">
        {fromFamilyGroup ? 'Mi grupo familiar' : 'Mi Historial médico'}
        <strong className="d-block fz-20 fw-semibold mt-5">Consultas médicas</strong>
      </Title>
      <Title border className="d-none lg:d-block">{fromFamilyGroup ? 'Mi grupo familiar' : 'Mi Historial médico'} <strong>/ Consultas médicas</strong></Title>
      
      <Text size="14" className="lg:fz-16 mt-30 lg:mt-40">
        {fromFamilyGroup 
          ? 'En esta sección podrás ver las próximas horas médicas de tu grupo familiar, consultas médicas anteriores y solicitar documentos asociados a ellas.' 
          : 'En esta sección podrás ver tus próximas horas médicas, consultas médicas anteriores y solicitar documentos asociados a ellas.'}
      </Text>
      
      {
        fromFamilyGroup === 'true' && (
          <Button 
            size="md" 
            color="primary" 
            className="mt-20 lg:mt-30" 
            component="link"
            to={`${config.ROUTES.DASHBOARD.FAMILYGROUP.HOME}`}
          >
            Volver a Mi Grupo Familiar
          </Button>
        )
      }

      <div className="mt-50 lg:mt-30">
        <Select
          name="tabOptions"
          sizes="md"
          color="primary"
          value={tabIndex}
          fullWidth
          className="lg:d-none"
          onChange={onTabSelectChange}
        >
          <option value="0">Próximas horas</option>
          <option value="1">Horas pasadas</option>
          <option value="2">Mis documentos</option>
        </Select>

        <Tabs
          selectedIndex={tabIndex}
          onSelect={index => setTabIndex(index)}
        >
          <TabList>
            <Tab className={tabClass}>Próximas horas</Tab>
            <Tab className={tabClass}>Horas pasadas</Tab>
            <Tab className={tabClass}>{fromFamilyGroup ? 'Documentos' : 'Mis documentos'}</Tab>
          </TabList>

          <TabPanel>
            <MedicalAppointmentsUpcomings
              data={appointmentUpcomingsData.data}
              familyFilter={familyFilter}
              familyFilterSelected={appointmentFilterSelected}
              onDataReload={onAppointmentDataReload}
            />
          </TabPanel>
          <TabPanel>
            <MedicalAppointments
              data={appointmentData.data}
              familyFilter={familyFilter}
              familyFilterSelected={appointmentFilterSelected}
              onDataReload={onAppointmentDataReload}
            />
          </TabPanel>
          <TabPanel>
            <MedicalAppointmentsDocuments 
              documents={appointmentDocumentsData.data} 
              fromFamilyGroup={fromFamilyGroup ? true : false} 
              familyFilter={familyFilter}
              familyFilterSelected={appointmentFilterSelected}
              familyMemberId={patientId || ''}
            />
          </TabPanel>
        </Tabs>
      </div>
    </Layout>
  )
}

export { MedicalAppointmentPage }